import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
function We() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    const { t } = useTranslation();
    return (
        <div className="withdraw px-[15px] py-[20px] min-h-[920px] bg-[#f2f2f2]">
            <div className="bg-[#fff] text-2xl rounded-2xl py-4 px-4 leading-10">
                <span>{t('content.we.1')}</span>
                <br />
                <br />
                <span>{t('content.we.2')}</span>
                <br />
                <br />
                <span>{t('content.we.3')}</span>
                <br />
                <br />
                <span>{t('content.we.4')}</span>
                <br />
                <br />
                <span>{t('content.we.5')}</span>
                <br />
                <br />
                <span>{t('content.we.6')}</span>
                <br />
                <br />
                <span>{t('content.we.7')}</span>
                <br />
                <br />
                <span>{t('content.we.8')}</span>
                <br />
                <br />
                <span>{t('content.we.9')}</span>
            </div>
        </div>
    );
}

export default We;
